import React from 'react';
import { FormattedMessage } from 'react-intl';

import { CARD_BANNER_VARIANTS } from '@ratehub/base-ui';

import COMMON_MESSAGES from '../definitions/Messages';
import getGiftOfferSummary from './getGiftOfferSummary';
import isCardEligibleForReferralOffer from './isCardEligibleForReferralOffer';


/**
 * Return an object with a string or React message array and a banner type suitable to be used for a simple banner
 * above a credit card, based on a gift offer or eligible referral offer associated with the card.
 * If neither of those conditions apply, returns `null`.
 *
 * @param {object} args
 * @param {GiftOfferShape} args.giftCardOffer - the card’s gift offer, if any
 * @param {boolean} args.hasReferralOffer - is this card eligible for a referral offer?
 * @param {import('react-intl').IntlShape} intl - the internationalization object
 * @return {null|{message: import('prop-types').PropType.node, variant: string}}
 */
function getCardBannerProps({ giftCardOffer, hasReferralOffer }, intl) {
    if (giftCardOffer) {
        return {
            message: getGiftOfferSummary({ giftCardOffer, intl }),
            variant: CARD_BANNER_VARIANTS.giftOffer,
        };
    }

    if (isCardEligibleForReferralOffer({ hasReferralOffer })) {
        return {
            message: (
                <FormattedMessage {...COMMON_MESSAGES.eligibleForReferralBonus} />
            ),
            variant: CARD_BANNER_VARIANTS.referralOffer,
        };
    }

    return null;
}


export default getCardBannerProps;
